var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[(_vm.img)?_c('div',{class:(_vm.className + "__img")}):_vm._e(),_c('div',{class:(_vm.className + "__content")},[_c('div',{class:(_vm.className + "__title")}),_c('div',{class:(_vm.className + "__subtitle")})])])}
var staticRenderFns = []

export { render, staticRenderFns }